import { numberFormatterWithOptional2Dp } from 'Utils/Formatters'

/**
 * Renders cell data
 * @param {string|number} val
 * @param {boolean}
 * @returns {string}
 */
export const renderCellData = (
  val,
  showAsPercent = false,
  key,
  currencySign,
) => {
  if ((key && ['hardCost'].includes(key)) || (key && key.includes('-cps'))) {
    return `${currencySign ? currencySign : '$'}${val.toFixed(2)}`
  }
  if (typeof val === 'number') {
    if (showAsPercent) return numberFormatterWithOptional2Dp(val * 100) + '%'
    return new Intl.NumberFormat('en-US').format(
      numberFormatterWithOptional2Dp(val),
    )
  }
  if (typeof val === 'string') return val
  return '-'
}



// WEBPACK FOOTER //
// ./src/Components/Stats/ResultsTable/util.js